module.exports = __webpack_public_path__ + "img/meditation_1.f1fe10df.svg";